module.exports = __webpack_public_path__ + "img/uchinokomon@2x.ea00d30b.png";